import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CampaignForm,
  ChatResponse,
  ConversationThreadDetail,
  ConversationThreadSummary,
  ConversationThreadResponse,
  Person,
  ResolveAudienceResponse,
  SendCampaignResponse,
  AudienceSelection,
} from '../models/campaign.model';
import {
  DashboardApprovalRow,
  DashboardRequestRow,
} from '../models/dashboard.model';
import { HttpService } from '~/core/services/http.service';

@Injectable({ providedIn: 'root' })
export class ApiService {
  constructor(private httpService: HttpService) { }

  health(): Observable<any> {
    return this.httpService.health();
  }

  getTeams(): Observable<string[]> {
    return this.httpService.getTeams();
  }

  getLocations(): Observable<string[]> {
    return this.httpService.getLocations();
  }

  searchPeople(query: string, top = 500): Observable<Person[]> {
    return this.httpService.searchPeople(query, top) as Observable<Person[]>;
  }

  searchApprovers(query = '', top = 25): Observable<Person[]> {
    return this.httpService.searchApprovers(query, top) as Observable<Person[]>;
  }

  generateCampaign(prompt: string): Observable<CampaignForm> {
    return this.httpService.generateCampaign(prompt) as Observable<CampaignForm>;
  }

  createConversationThread(): Observable<ConversationThreadResponse> {
    return this.httpService.createConversationThread() as Observable<ConversationThreadResponse>;
  }

  listConversationThreads(): Observable<ConversationThreadSummary[]> {
    return this.httpService.listConversationThreads() as Observable<ConversationThreadSummary[]>;
  }

  getConversationThread(threadId: string): Observable<ConversationThreadDetail> {
    return this.httpService.getConversationThread(threadId) as Observable<ConversationThreadDetail>;
  }

  deleteConversationThread(threadId: string): Observable<void> {
    return this.httpService.deleteConversationThread(threadId) as Observable<void>;
  }

  clearConversationThreads(): Observable<void> {
    return this.httpService.clearConversationThreads() as Observable<void>;
  }

  chat(message: string, currentForm: CampaignForm, threadId: string | null): Observable<ChatResponse> {
    return this.httpService.chat(message, currentForm, threadId) as Observable<ChatResponse>;
  }

  resolveAudience(audience: AudienceSelection): Observable<ResolveAudienceResponse> {
    return this.httpService.resolveAudience(audience) as Observable<ResolveAudienceResponse>;
  }

  sendCampaign(
    campaign: CampaignForm,
    threadId: string | null,
    messageId: number | null,
  ): Observable<SendCampaignResponse> {
    return this.httpService.sendCampaign(campaign, threadId, messageId) as Observable<SendCampaignResponse>;
  }

  getDashboardRequests(): Observable<DashboardRequestRow[]> {
    return this.httpService.getDashboardRequests() as Observable<DashboardRequestRow[]>;
  }

  getDashboardApprovals(): Observable<DashboardApprovalRow[]> {
    return this.httpService.getDashboardApprovals() as Observable<DashboardApprovalRow[]>;
  }

  fetchPhotoBlob(photoPath: string): Observable<Blob> {
    return this.httpService.fetchPhotoBlob(photoPath);
  }
}
